import { ChangeDetectorRef, Directive, ElementRef, Input, Renderer2 } from '@angular/core';

@Directive({
  selector: '[appScrollMenuItem]',
})
export class ScrollMenuItemDirective {
  @Input() appScrollMenuItemActive = 'active';

  get rect(): number {
    return this.elementRef.nativeElement.getBoundingClientRect();
  }

  constructor(
    readonly elementRef: ElementRef,
    private readonly renderer: Renderer2,
    private readonly cdr: ChangeDetectorRef
  ) {}

  toggleClass(addClass: boolean) {
    if (addClass) {
      this.renderer.addClass(this.elementRef.nativeElement, this.appScrollMenuItemActive);
    } else {
      this.renderer.removeClass(this.elementRef.nativeElement, this.appScrollMenuItemActive);
    }

    this.cdr.markForCheck();
  }
}
